module.exports = __webpack_public_path__ + "static/img/04.943bfbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat/04.png
// module id = HX/X
// module chunks = 0